<template>
 <div class="learnmore">
  <a-button class="learnmore-btn" type="primary" @click="goLink">了解更多</a-button>
 </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'


const props = defineProps({
 path: {
  type: String,
  default: () => ""
 },
 type: {
  type: String,
  default: () => "router"
 },
 query: {
  type: Object,
  default: () => {
   return {}
  }
 }
})
const router = useRouter()

const path = computed(() => props.path)

const goLink = () => {

 if (props.type === 'router') {
  console.log(props.query);

  router.push({
   path: path.value,
   query: props.query
  })
 } else {
  window.open(path.value, '_blank')
 }

}
</script>

<style scoped lang="less">
.learnmore {
 width: 100%;
 height: 100px;
 text-align: center;
 line-height: 100px;
 font-size: 20px;
 color: #000;
}

.learnmore-btn {
 width: 210px;
 height: 46px;
 border-radius: 10px;
}
</style>